import MainPage from "./Component/MainPage";
function App() {
  return (
   <>
   <MainPage/>
   </>
  );
}

export default App;
